// extracted by mini-css-extract-plugin
module.exports = {"back-to-top":"cI","backToTop":"cI"};